// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__DCWLz","textarea":"FormInput_textarea__fndMP"};